import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import './ChatChallengeChampion.scss';

const ChatChallengeChampion = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

    // Auto-close after animation completes (e.g., 5 seconds)
    useEffect(() => {
        const timer = setTimeout(() => {
            props.close();
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    // Create confetti elements
    const createConfetti = () => {
        const confettiElements = [];
        for (let i = 0; i < 50; i++) {
            const style = {
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                backgroundColor: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'][Math.floor(Math.random() * 6)]
            };
            confettiElements.push(<div key={i} className='confetti' style={style}></div>);
        }
        return confettiElements;
    };

    return (
        <div className='chat-challenge-champion'>
            <div className='confetti-container'>
                {createConfetti()}
            </div>
            
            {props.music && (
                <audio autoPlay loop>
                    <source src={props.music}></source>
                </audio>
            )}

            <div className='champion-content'>
                <h1 className='champion-title bounce-animation'>
                    Chat Challenge Champion!
                </h1>
                
                {props.animalImage && (
                    <div className='bouncing-animal'>
                        <img 
                            src={props.animalImage} 
                            alt='Champion Animal' 
                            className='animal-image'
                        />
                    </div>
                )}

                <div className='champion-message'>
                    <p>Congratulations, {props.studentName}!</p>
                    <p>You are now a Chat Challenge Champion!</p>
                </div>

                <div className='stars'>
                    <span className='star'>⭐</span>
                    <span className='star'>⭐</span>
                    <span className='star'>⭐</span>
                </div>
            </div>
        </div>
    );
};

export default ChatChallengeChampion;

